import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { getRouteByActivityType } from 'src/app/board/activity/activity-shared/activity-shared-routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';

export const activityGroupsRoutes: MenuInterface[] = [
    {
        code: 'GroupParameters',
        route: getRouteByActivityType('ActivityParameters', RouteActivityType.Groups)
    },
    {
        code: 'GroupParametersPermanence',
        route: getRouteByActivityType('PermanencesSettings', RouteActivityType.Groups)
    },
    {
        code: 'GroupCatalog',
        route: getRouteByActivityType('Catalog', RouteActivityType.Groups)
    },
    {
        code: 'GroupParametersForm',
        route: getRouteByActivityType('Forms', RouteActivityType.Groups)
    },
    {
        code: 'GroupActions',
        route: getRouteByActivityType('GroupedActions', RouteActivityType.Groups)
    },
    {
        code: 'GroupParametersFormFields',
        route: getRouteByActivityType('FormField', RouteActivityType.Groups)
    },
    {
        code: 'GroupSalesList',
        route: getRouteByActivityType('OrderList', RouteActivityType.Groups)
    },
    {
        code: 'GroupInvoicesList',
        route: getRouteByActivityType('InvoicesList', RouteActivityType.Groups)
    },
    {
        code: 'GroupSuppliersFreeOrdersList',
        route: getRouteByActivityType('SuppliersFreeOrdersList', RouteActivityType.Groups)
    },
    {
        code: 'GroupSuppliersFreeInvoicesList',
        route: getRouteByActivityType('SuppliersFreeInvoicesList', RouteActivityType.Groups),
    },
    {
        code: 'GroupBeneficiariesFreeOrdersList',
        route: getRouteByActivityType('BeneficiariesFreeOrdersList', RouteActivityType.Groups)
    },
    {
        code: 'GroupBeneficiariesFreeInvoicesList',
        route: getRouteByActivityType('BeneficiariesFreeInvoicesList', RouteActivityType.Groups),
    },
    {
        code: 'GroupFreeEntriesModelsList',
        route: getRouteByActivityType('FreeEntriesModelsList', RouteActivityType.Groups)
    },
    {
        code: 'GroupParametersStatusManagement',
        route: getRouteByActivityType('StatusParameters', RouteActivityType.Groups)
    },
    {
        code: 'GroupPrintDashboard',
        route: getRouteByActivityType('PrintDashboard', RouteActivityType.Groups)
    },
    {
        code: 'GroupPrintSalesBalance',
        route: getRouteByActivityType('PrintSalesBalance', RouteActivityType.Groups)
    },
    {
        code: 'GroupPrintFormOrders',
        route: getRouteByActivityType('PrintSalesBalance', RouteActivityType.Groups)
    },
    {
        code: 'GroupSubscriptionNew',
        route: getRouteByActivityType('NewSale', RouteActivityType.Groups)
    },
    {
        code: 'GroupAllocation',
        route: getRouteByActivityType('Allocation', RouteActivityType.Groups)
    },
    {
        code: 'GroupParametersCancellationFees',
        route: getRouteByActivityType('ActivityParametersCancellationFees', RouteActivityType.Groups)
    },
    {
        code: 'GroupParametersChoiceSession',
        route: getRouteByActivityType('ChoiceSession', RouteActivityType.Groups)
    },
    {
        code: 'GroupPrintEmargementsList',
        route: [
            {
                content: 'activity/groups/prints/filters/attendances',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'GroupPrintBookingsList',
        route: [
            {
                content: 'activity/groups/prints/filters/reservations',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'GroupSubscription',
        route: [
            {
                content: 'activity/groups/registrations/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'GroupRoomingsList',
        route: [
            {
                content: 'activity/groups/regrouping/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GroupParametersModelsLetter',
        route: [
            {
                content: 'activity/groups/settings/models/letter/list',
                focus: 'empty'
            }, 'content'
        ]
    },
];
